import React, { useEffect } from 'react';
import { DailySettlementContext, IDailySettlementContext } from './DailySettlementContext';
import { useAsyncData } from '@shared/react';
import { useErrorNotify } from '@features/useErrorNotify';
import { getDailySettlement } from './api';

export const DailySettlementProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const {
        data: dailySettlement,
        loading: dailySettlementLoading,
        error: dailySettlementError,
        handleRefresh: refreshDailySettlement,
    } = useAsyncData(
        async () => {
            return await getDailySettlement();
        },
        null,
        [],
    );

    useEffect(() => {
        const interval = setInterval(() => {
            refreshDailySettlement();
        }, 15000);

        return () => clearInterval(interval);
    }, [refreshDailySettlement]);

    useErrorNotify(dailySettlementError, 'Daily Settlement');

    const value: IDailySettlementContext = {
        refreshDailySettlement,
        dailySettlement,
        dailySettlementLoading,
    };

    return <DailySettlementContext.Provider value={value}>{children}</DailySettlementContext.Provider>;
};
